import pinia from "@/plugins/pinia";
import { useReportStore } from "@/store/report";
import { BaseMenuEntry } from "./base-menu-entry";

export class ReportsMenuEntry extends BaseMenuEntry
{
    protected reportStore = useReportStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/09-reports.svg");
    }

    public isEnabled() : boolean
    {
        return this.reportStore.validationDate !== null;
    }

    public isValid() : boolean
    {
        return true; // Always valid (as soon as it is enabled)
    }

    public isValidated() : boolean
    {
        return true; // Always validated
    }

    public toggleValidation() : void
    {
        // Validation is not controllable by the user
        return;
    }
}
